import call from "./call";
import {
  AppendixItem,
  EvaluationResponse,
  MoreInfoResponse,
} from "../Models/evaluation";
import { evaluationModelAccessResponse } from "../Models/evaluationModel";

// TODO: refactor this catch logic / move it out of this function into UI layer
export const fetchEvaluate = async (
  company_id: number,
  model_id: number,
  questionListId: string,
  certificate_id: string,
  languageId: number,
  appendix: AppendixItem[],
  configOverrides?: Record<string, number | boolean | string>
): Promise<EvaluationResponse | MoreInfoResponse> => {
  try {
    const { data } = await call.post<EvaluationResponse | MoreInfoResponse>(
      "/v1/evaluation/",
      {
        company_id: company_id,
        model_id: model_id,
        question_list_id: questionListId,
        certificate_id: certificate_id,
        language: languageId,
        appendix,
        ...(configOverrides &&
          Object.keys(configOverrides).length > 0 && {
            config_overrides: configOverrides,
          }),
      },
      {
        snack: {
          409: null,
          418: null,
          423: null,
          error: "llm.evaluationRequestError",
        },
      }
    );

    return data;
  } catch (error: any) {
    if (error.response && error.response.status === 418) {
      throw new Error(
        `You have exceeded the evaluation request limit. Please try again later.`
      );
    } else if (error.response && error.response.status === 423) {
      throw new Error(
        `Evaluation cannot be performed at the moment as files are still being processed.`
      );
    } else if (error.response && error.response.status === 409) {
      const evaluationId = error.response.data.evaluation_id;
      throw {
        status: 409,
        evaluationId: evaluationId,
      };
    } else if (error.response && error.response.data) {
      throw new Error(error.response.data.error || "An error occurred.");
    } else if (error.request && error.request.responseText) {
      try {
        const parsedError = JSON.parse(error.request.responseText);
        throw new Error(parsedError.error || "An error occurred.");
      } catch {
        throw new Error("An error occurred while parsing the response.");
      }
    } else {
      throw new Error("An unexpected error occurred.");
    }
  }
};

export const fetchModelOptions = async () => {
  const response =
    await call.get<evaluationModelAccessResponse>("/v1/llm/models/");
  return response.data;
};
